import './src/styles/global.css'
import './src/styles/index.scss';
